import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { getBookingDetailsServ } from "../../services/bookingDashboard.services";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const OrderDetails = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [list, setList] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const navigate = useNavigate();
  const [showSkelton, setShowSkelton] = useState(false);

  useEffect(() => {
    fetchOrderDetails();
  }, [id]);

  const fetchOrderDetails = async () => {
    if (list.length == 0) {
      setShowSkelton(true);
    }
    try {
      const res = await getBookingDetailsServ(id);
      setOrder(res?.data?.data);
    } catch (error) {
      console.error("Failed to fetch order details:", error);
    } finally {
      setShowSkelton(false);
    }
  };

  if (!order) return <div className="p-4">No order found.</div>;

  const user = order?.userId || {};
  const address = order?.address || {};
  const products = order?.product || [];
  const comboProduct = order?.comboProduct || [];
  const variantProduct = order?.variantProduct || [];

  const handleOpenPaymentModal = () => setShowPaymentModal(true);
  const handleClosePaymentModal = () => setShowPaymentModal(false);

  const isPaymentUploaded = order?.paymentSs;

  // keys grouped per stage so legacy status values (outForDelivery, completed)
  // still land on the right step after the status list was expanded
  const statusFlow = [
    { key: "orderPlaced", keys: ["orderPlaced"], icon: "🛒", label: "Order Placed" },
    { key: "orderConfirmed", keys: ["orderConfirmed"], icon: "✅", label: "Order Confirmed" },
    { key: "orderPacked", keys: ["orderPacked"], icon: "📦", label: "Order Packed" },
    { key: "shipped", keys: ["shipped"], icon: "🚚", label: "Order Shipped" },
    { key: "inTransit", keys: ["inTransit", "outForDelivery"], icon: "📍", label: "In Transit" },
    { key: "delivered", keys: ["delivered", "completed"], icon: "✅", label: "Order Delivered" },
  ];

  return (
    <div className="bodyContainer">
      <Sidebar selectedMenu="Orders" selectedItem="Orders" />
      <div className="mainContainer">
        <TopNav />
        <div className="container-fluid p-lg-4 p-md-3 p-2">
          <div className="row g-4">
            {/* Left Column */}
            <div className="col-lg-8">
              <div className="card shadow-sm p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="mb-0">
                    Order #{order?._id?.slice(0, 6).toUpperCase()}
                  </h4>
                  <button
                    className="btn"
                    onClick={() => navigate(`/order-invoice/${order?._id}`)}
                    style={{
                      backgroundColor: "#28c76f",
                      color: "#fff",
                      fontWeight: "600",
                      border: "none",
                      borderRadius: "5px",
                      padding: "8px 12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i className="fa fa-download"></i> Invoice
                  </button>
                </div>

                <table className="table">
                  <thead className="table-light">
                    <tr>
                      <th>Product Details</th>
                      <th>Item Price</th>
                      <th>Quantity</th>
                      <th>total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((item, i) => (
                      <tr key={i}>
                        <td>
                          <img
                            src={item?.productId?.productHeroImage}
                            alt="product"
                            style={{ width: 50 }}
                          />
                          <strong className="m-4">
                            {item?.productId?.name}
                          </strong>
                        </td>
                        <td>
                          ₹
                          {item?.productId?.discountedPrice ||
                            item?.productId?.price}
                        </td>
                        <td>{item?.quantity || 1}</td>
                        <td>
                          ₹
                          {(
                            (item?.productId?.discountedPrice ||
                              item?.productId?.price ||
                              0) * (item?.quantity || 1)
                          ).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                    {comboProduct.map((item, i) => (
                      <tr key={i}>
                        <td>
                          <img
                            src={item?.comboProductId?.productHeroImage}
                            alt="product"
                            style={{ width: 50 }}
                          />
                          <strong className="m-4">
                            {item?.comboProductId?.name}
                          </strong>
                        </td>
                        <td>₹{item?.comboProductId?.comboPrice}</td>
                        <td>{item?.quantity || 1}</td>
                        <td>
                          ₹
                          {(
                            (item?.comboProductId?.comboPrice ||
                              item?.comboProductId?.price ||
                              0) * (item?.quantity || 1)
                          ).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                    {variantProduct.map((item, i) => (
                      <tr key={i}>
                        <td>
                          <img
                            src={item?.productId?.productHeroImage}
                            alt="product"
                            style={{ width: 50 }}
                          />
                          <strong className="m-4">
                            {item?.productId?.name} (
                              {
                            item?.productId?.productVariants?.filter(
                              (variant, i) => {
                                return variant?._id == item?.variantId;
                              }
                            )[0].variantValue
                          }
                            )
                          </strong>
                        </td>
                        <td>
                          ₹ (
                          {
                            item?.productId?.productVariants?.filter(
                              (variant, i) => {
                                return variant?._id == item?.variantId;
                              }
                            )[0].variantDiscountedPrice
                          }
                          )
                        </td>
                        <td>{item?.quantity || 1}</td>
                        <td>
                          ₹
                          {(
                            (item?.totalPrice || 0) * (item?.quantity || 1)
                          ).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="d-flex flex-column align-items-end mt-3">
                  <div>Subtotal: ₹{order?.totalAmount}</div>
                  <div>Shipping: ₹{order?.deliveryCharge || 0}</div>
                  
                  <div className="fw-bold">
  Total: ₹{parseInt(order?.totalAmount || 0) + parseInt(order?.deliveryCharge || 0)}
</div>

                </div>
              </div>

              {/* Order Status */}
              <div className="card shadow-sm p-4 mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Order Status</h5>
                </div>

                <ul className="order-tracker ps-0">
                  {statusFlow.map((step) => {
                    const achieved = (order?.statusHistory || []).find((h) =>
                      step.keys.includes(h.status)
                    );
                    const isActive = step.keys.includes(order?.status);
                    const isCompleted = !!achieved && !isActive;

                    return (
                      <li
                        key={step.key}
                        className={
                          isCompleted ? "completed" : isActive ? "active" : "pending"
                        }
                      >
                        <div className="icon">{step.icon}</div>
                        <div className="details">
                          <strong>
                            {step.label}
                            {achieved &&
                              ` - ${moment(achieved.updatedAt).format("ddd, DD MMM YYYY")}`}
                          </strong>

                          {achieved && (
                            <div className="text-muted small">
                              {moment(achieved.updatedAt).format(
                                "ddd, DD MMM YYYY - h:mmA"
                              )}
                              {step.key === "shipped" &&
                                (order?.courierPartner || order?.trackingNumber) && (
                                  <>
                                    <br />
                                    <strong>
                                      {order?.courierPartner}
                                      {order?.trackingNumber
                                        ? ` – ${order.trackingNumber}`
                                        : ""}
                                    </strong>
                                  </>
                                )}
                            </div>
                          )}
                        </div>
                      </li>
                    );
                  })}

                  {order?.status === "cancelled" && (
                    <li className="active">
                      <div className="icon">❌</div>
                      <div className="details">
                        <strong>Cancelled</strong>
                        <div className="text-muted small text-danger">
                          This order was cancelled.
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-lg-4">
              {/* Logistics */}
              {/* <div className="card shadow-sm p-3 mb-4">
                <h6 className="fw-bold mb-2">Logistics Details</h6>
                <div>
                  Courier: <strong>RQP Logistics</strong>
                </div>
                <div>
                  Tracking ID: <strong>{order?.paymentId || "N/A"}</strong>
                </div>
                <div>Payment Mode: {order?.modeOfPayment}</div>
                <button className="btn btn-sm btn-primary mt-2">
                  Track Order
                </button>
              </div> */}

              {/* Customer Details */}
              <div className="card shadow-sm p-3 mb-4">
                <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                  <h6 className="fw-bold mb-0">Customer Details</h6>
                  {/* <a
                    href={/profile/${user?._id}}
                    className="text-decoration-none fw-medium"
                    style={{ color: "#7F56D9" }}
                  >
                    View Profile
                  </a> */}
                </div>

                <div className="d-flex align-items-center mb-3">
                  <img
                    src={
                      user?.profilePic
                        ? user?.profilePic
                        : "https://cdn-icons-png.flaticon.com/128/149/149071.png"
                    }
                    alt="profile"
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                    }}
                  />
                  <div className="ms-3">
                    <div className="fw-semibold">
                      {user?.firstName} {user?.lastName}
                    </div>
                    <div className="text-muted small">Customer</div>
                  </div>
                </div>

                <div className="mb-2 d-flex align-items-center">
                  <i className="fa fa-envelope me-2 text-muted"></i>
                  <span>{user?.email || "-"}</span>
                </div>

                <div className="d-flex align-items-center">
                  <i className="fa fa-phone me-2 text-muted"></i>
                  <span>{user?.phone || "-"}</span>
                </div>
              </div>

              {/* Shipping Address */}
              <div className="card shadow-sm p-3 mb-4">
                <h6 className="fw-bold mb-2">Shipping Address</h6>
                <div>{address.fullName}</div>
                <div>{address.phone}</div>
                <div>
                  {address.area}, {address.city}, {address.state} -{" "}
                  {address.pincode}
                </div>
                <div>{address.country}</div>
              </div>

              {/* Payment Details */}
              <div className="card shadow-sm p-3 mb-4">
                <h6 className="fw-bold mb-3">Payment Details</h6>

                <div>Transaction ID: #{order?.paymentId || "N/A"}</div>
                <div>Payment Mode: {order?.modeOfPayment || "-"}</div>
                <div>Total Paid: ₹{order?.totalAmount || "-"}</div>

                <div className="d-flex align-items-center mt-2">
                  <div className="me-2 fw-medium">
                    Payment Screenshot:{" "}
                    {isPaymentUploaded ? (
                      <span className="text-success">Uploaded</span>
                    ) : (
                      <span className="text-danger">Not Uploaded</span>
                    )}
                  </div>

                  {isPaymentUploaded && (
                    <button
                      onClick={handleOpenPaymentModal}
                      className="btn"
                      title="View Screenshot"
                    >
                      <i className="fa fa-eye"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showPaymentModal} onHide={handleClosePaymentModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Payment Screenshot</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img
            src={order?.paymentSs}
            alt="Payment Screenshot"
            className="img-fluid rounded"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePaymentModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OrderDetails;
